import * as yup from 'yup';

import { strings } from '../strings';

export enum ChangePasswordField {
  CURRENT_PASSWORD = 'currentPassword',
  NEW_PASSWORD = 'newPassword',
  CONFIRM_NEW_PASSWORD = 'confirmNewPassword',
}

export const changePasswordSchema = yup.object().shape({
  [ChangePasswordField.CURRENT_PASSWORD]: yup
    .string()
    .trim()
    .required(strings.currentPasswordRequired),

  [ChangePasswordField.NEW_PASSWORD]: yup
    .string()
    .trim()
    .required(strings.newPasswordRequired)
    .min(6, strings.passwordMinCharacters),
  [ChangePasswordField.CONFIRM_NEW_PASSWORD]: yup
    .string()
    .trim()
    .required(strings.confirmPasswordRequired)
    .oneOf([yup.ref(ChangePasswordField.NEW_PASSWORD)], strings.passwordMatches),
});
